import {ListMapOperationQuery, MapOperation} from "../API";
import {API, graphqlOperation} from "aws-amplify";
import {listMapOperation} from "./queries";
import {debug_log} from "../utils/debug";
import {createMapOperation, deleteMapOperation} from "./mutations";
import {Operation} from "../models/Operation";

export async function fetchJourneyMapOperations(mapId: string, nextToken?: string): Promise<MapOperation[]> {
    let operations: MapOperation[] = [];

    const res = await API.graphql(graphqlOperation(listMapOperation, {
        mapId: mapId,
        sortDirection: 'ASC',
        nextToken: nextToken
    })) as { data: ListMapOperationQuery };

    if (res.data.listMapOperation) {
        res.data.listMapOperation.items?.forEach((op) => {
            if (op) {
                operations.push(op);
            }
        });

        if (res.data.listMapOperation.nextToken) {
            operations = operations.concat(await fetchJourneyMapOperations(mapId, res.data.listMapOperation.nextToken));
        }
    }

    return operations;
}

export async function removeOperation(ops: MapOperation[]) {
    for (const op of ops) {
        debug_log("remove operation", op);
        await API.graphql(graphqlOperation(
            deleteMapOperation, {input: {id: op.id}})
        );
    }
}

export async function storeJourneyMapOperations(mapId: string, op: Operation): Promise<any> {
    return API.graphql(graphqlOperation(
        createMapOperation, {
            input: {
                mapId: mapId,
                type: op.type,
                data: JSON.stringify(op.data)
            }
        }
    ));
}
